
export const isValidEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
};

export const filePathRegex = /^(\/|(\/[a-zA-Z0-9\-\_]+)+)$/;